import React, { useEffect } from "react";
import { SpinnerContainer } from "../../style/StyleComponentUtility";
import logoWhite from "../../assets/images/ablack_logo_w.png";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";

const Spinner: React.FC = () => {
    const commonData = useSelector((state: RootState) => state.commonData);
    useEffect(() => {
        document.body.classList.add('on-modal-back');

        return () => {
            document.body.classList.remove('on-modal-back');
        }
    }, []);

    return (
        <SpinnerContainer>
            <div className="spinner-box">
                <img src={logoWhite} alt="" className="h-12 animate-pulse" />
                <div className="spinner-text animate-pulse">
                    <span>{commonData.spinner_text}</span>
                </div>
            </div>
        </SpinnerContainer>
    )
};

export default Spinner;